import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    getAttribute: [],
    loading: false,
    error: null,
}

const getAttributeSlice = createSlice({
    name: "getAttribute",
    initialState,
    reducers: {
        fetchGetAttributeSucess: (state, action) => {
            state.loading = false
            state.getAttribute = action.payload;
        },
        fetchGetAttributeFailure: (state, action) => {
            state.loading = false
            state.error = action.payload;
        },
    },
})

export const {
    fetchGetAttributeSucess,
    fetchGetAttributeFailure,
} = getAttributeSlice.actions;

export default getAttributeSlice.reducer;